import React, { Component } from "react";
import "./style.scss";
import { Helmet } from "react-helmet";

class Experiences extends Component {
  render() {
    return (
      <div className="page Experiences">
        <Helmet>
          <title>Tanguy HELLER | Expériences</title>
        </Helmet>

        <h1>Experiences</h1>

        <div className="section">
          <div className="presentoir-wrapper">
            <div className="date">Autodidacte - 2019 - 2021</div>
            <div className="presentoir">
              <img src="/images/vgc_small.png" alt="vgc-logo" />
              <div className="text-section">
                <h2>VGC - Console de salon virtuelle</h2>
                <p>
                  Au cours de ma formation de chef de projet à l'IPI, j'ai
                  travaillé sur la création d'un projet en groupe, le projet
                  nous a tellement emballé que nous avons décidé avec un
                  camarade de le réaliser après notre contrat d'alternance.
                </p>
                <p>
                  Nous voulons créer une console de salon virtuelle, permettant
                  de jouer à des jeux communautaires sans restrictions de moyen,
                  il suffit d'un accès internet d'un smartphone par personne.
                </p>
                <p>
                  Actuellement nous avons développé la console VGC (Virtual
                  Gaming Console) ainsi que son premier jeu, cependant le
                  contexte sanitaire actuel nous empêche de mettre en oeuvre
                  notre campagne de communication.
                </p>
                <p>
                  Le projet est divisée en 3 parties principales, la console est
                  développée avec <b>ReactJS</b>, <b>React Native</b> et{" "}
                  <b>Node.JS</b>. Le back-end avec <b>NodeJS</b>, <b>MongoDB</b>{" "}
                  et <b>WebSocket</b>. Et le jeu est développé sous <b>Unity</b>{" "}
                  en <b>C#</b>.
                </p>
                <p>
                  Nous utilisons <b>Git</b> pour partager le code & gérer les
                  versions de chacune des parties du projet. Particulièrement
                  l'outil <b>Gitlab</b> qui nous permet, entre autre, la gestion
                  de l'avancée du projet et la mise en ligne automatique de la
                  partie web grâce au système de <b>Pipelines (DevOps)</b>.
                </p>
              </div>
            </div>
          </div>
        </div>

        <br />

        <div className="section">
          <div className="presentoir-wrapper">
            <div className="date">IRT Saint-Exupéry - 2016 - 2019</div>
            <div className="presentoir">
              <img src="/images/irt-logo.png" alt="irt-logo" />
              <div className="text-section">
                <h2>Alternance - Concepteur Développeur d'applications</h2>
                <p>
                  J'ai passé mes 3 années de formation à l'IPI en alternance, je
                  suis donc intervenu sur plusieurs tâches au sein du projet.
                </p>
                <p>
                  Lors de la première année j'ai travaillé à la réalisation d'un
                  nouvel outil web en interne ce qui m'a permis d'apprendre et
                  d'utiliser les langages <b>HTML</b>, <b>CSS</b>,{" "}
                  <b>Javascript</b> et de découvrir des technologies comme{" "}
                  <b>Node.js</b>, <b>JQuery</b>, <b>Docker</b>. J'ai aussi pu
                  découvrir l'environnement <b>Linux</b>.
                </p>
                <p>
                  Au cours des 2 années suivantes j'ai{" "}
                  <b>pris en charge l'amélioration</b> de l'outil que j'avais
                  développé l'année précédente en mettant en place un cycle{" "}
                  <b>Agile</b> pour que mon produit corresponde aux besoins des
                  utilisateurs.
                </p>
                <p>
                  Je suis également intervenu sur la maintenance d'une autre
                  application pour mes compétences <b>Java</b> & <b>JavaFX</b>.
                </p>
              </div>
            </div>
          </div>
        </div>

        <br />

        <div className="section">
          <div className="presentoir-wrapper">
            <div className="date">IRT Saint-Exupéry - 2016</div>
            <div className="presentoir">
              <img src="/images/irt-logo.png" alt="irt-logo" />
              <div className="text-section">
                <h2>Stage | Développeur Java/JavaFX junior</h2>
                <p>
                  Au cours de mon stage de fin d'étude j'ai pu mettre en
                  pratique mes connaissances et faire mes premiers pas en
                  entreprise.
                </p>
                <p>
                  Ma mission a été de réaliser une <b>IHM</b> pour évaluer un
                  simulateur de missions satellites. Pour la mener à bien j'ai
                  développé avec les langages <b>Java</b> & <b>JavaFX</b>, en
                  utilisant l'environnement <b>Eclipse</b> et <b>Git</b>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Experiences;
